import React, { useState, lazy } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Footer } from '../components/Footer';
import { X, ChevronLeft, ChevronRight } from 'lucide-react';
const IMAGES = [{
  id: 1,
  category: 'Weddings',
  url: 'https://images.unsplash.com/photo-1519741497674-611481863552?w=600&q=80'
}, {
  id: 2,
  category: 'Weddings',
  url: 'https://images.unsplash.com/photo-1465495976277-4387d4b0b4c6?w=600&q=80'
}, {
  id: 3,
  category: 'Weddings',
  url: 'https://images.unsplash.com/photo-1519225421980-715cb0215aed?w=600&q=80'
}, {
  id: 4,
  category: 'Weddings',
  url: 'https://images.unsplash.com/photo-1507504031003-b417219a0fde?w=600&q=80'
}, {
  id: 5,
  category: 'Birthdays',
  url: 'https://images.unsplash.com/photo-1530103862676-de8c9debad1d?w=600&q=80'
}, {
  id: 6,
  category: 'Birthdays',
  url: 'https://images.unsplash.com/photo-1464349153735-7db50ed83c84?w=600&q=80'
}, {
  id: 7,
  category: 'Birthdays',
  url: 'https://images.unsplash.com/photo-1513151233558-d860c5398176?w=600&q=80'
}, {
  id: 8,
  category: 'Corporate',
  url: 'https://images.unsplash.com/photo-1540575467063-178a50c2df87?w=600&q=80'
}, {
  id: 9,
  category: 'Corporate',
  url: 'https://images.unsplash.com/photo-1505373877841-8d25f7d46678?w=600&q=80'
}, {
  id: 10,
  category: 'Corporate',
  url: 'https://images.unsplash.com/photo-1587825140708-dfaf18c4f4d4?w=600&q=80'
}, {
  id: 11,
  category: 'Venue',
  url: 'https://images.unsplash.com/photo-1519167758481-83f550bb49b3?w=600&q=80'
}, {
  id: 12,
  category: 'Venue',
  url: 'https://images.unsplash.com/photo-1511795409834-ef04bbd61622?w=600&q=80'
}, {
  id: 13,
  category: 'Venue',
  url: 'https://images.unsplash.com/photo-1464366400600-7168b8af9bc3?w=600&q=80'
}];
const CATEGORIES = ['All', 'Weddings', 'Birthdays', 'Corporate', 'Venue'];
export function GalleryPage() {
  const [activeTab, setActiveTab] = useState('All');
  const [lightboxIndex, setLightboxIndex] = useState<number | null>(null);
  const filteredImages = activeTab === 'All' ? IMAGES : IMAGES.filter(img => img.category === activeTab);
  const openLightbox = (index: number) => setLightboxIndex(index);
  const closeLightbox = () => setLightboxIndex(null);
  const nextImage = (e: React.MouseEvent) => {
    e.stopPropagation();
    if (lightboxIndex !== null) {
      setLightboxIndex((lightboxIndex + 1) % filteredImages.length);
    }
  };
  const prevImage = (e: React.MouseEvent) => {
    e.stopPropagation();
    if (lightboxIndex !== null) {
      setLightboxIndex((lightboxIndex - 1 + filteredImages.length) % filteredImages.length);
    }
  };
  return <motion.main initial={{
    opacity: 0
  }} animate={{
    opacity: 1
  }} exit={{
    opacity: 0
  }} className="min-h-screen w-full bg-h2o-950 text-slate-100 flex flex-col pt-20" data-id="element-394">
      {/* Hero Banner */}
      <section className="relative h-[40vh] min-h-[300px] flex items-center justify-center overflow-hidden" data-id="element-395">
        <div className="absolute inset-0 z-0" data-id="element-396">
          <img src="https://images.unsplash.com/photo-1519225421980-715cb0215aed?w=1920&q=80" alt="Gallery" className="w-full h-full object-cover object-center" data-id="element-397" />
          <div className="absolute inset-0 bg-h2o-950/80" data-id="element-398" />
        </div>
        <div className="relative z-10 text-center px-6" data-id="element-399">
          <motion.h1 initial={{
          y: 20,
          opacity: 0
        }} animate={{
          y: 0,
          opacity: 1
        }} transition={{
          delay: 0.2
        }} className="text-4xl md:text-6xl font-bold text-white mb-4" data-id="element-400">
            Gallery
          </motion.h1>
          <motion.p initial={{
          y: 20,
          opacity: 0
        }} animate={{
          y: 0,
          opacity: 1
        }} transition={{
          delay: 0.3
        }} className="text-lg text-slate-300 max-w-2xl mx-auto" data-id="element-401">
            A glimpse into the unforgettable moments created at H2O Event
            Centre.
          </motion.p>
        </div>
      </section>

      {/* Gallery Section */}
      <section className="py-16 px-6 md:px-12 max-w-7xl mx-auto w-full" data-id="element-402">
        {/* Tabs */}
        <div className="flex flex-wrap justify-center gap-3 mb-12" data-id="element-403">
          {CATEGORIES.map(cat => <button key={cat} onClick={() => setActiveTab(cat)} className={`relative px-6 py-2 rounded-full text-sm font-medium transition-colors focus-visible-ring ${activeTab === cat ? 'text-h2o-950' : 'text-slate-300 hover:text-white bg-h2o-800/50'}`} data-id="element-404">
              {activeTab === cat && <motion.div layoutId="active-tab" className="absolute inset-0 bg-h2o-cyan rounded-full -z-10" transition={{
            type: 'spring',
            stiffness: 300,
            damping: 30
          }} data-id="element-405" />}
              {cat}
            </button>)}
        </div>

        {/* Masonry Grid */}
        <motion.div layout className="columns-1 sm:columns-2 md:columns-3 lg:columns-4 gap-4 space-y-4" data-id="element-406">
          <AnimatePresence data-id="element-407">
            {filteredImages.map((img, index) => <motion.div layout initial={{
            opacity: 0,
            scale: 0.9
          }} animate={{
            opacity: 1,
            scale: 1
          }} exit={{
            opacity: 0,
            scale: 0.9
          }} transition={{
            duration: 0.3
          }} key={img.id} className="break-inside-avoid relative group cursor-pointer rounded-lg overflow-hidden" onClick={() => openLightbox(index)} data-id="element-408">
                <img src={img.url} alt={`Gallery ${img.category}`} className="w-full h-auto object-cover" loading="lazy" data-id="element-409" />
                <div className="absolute inset-0 bg-h2o-950/60 opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex items-center justify-center" data-id="element-410">
                  <span className="text-white font-medium tracking-wider uppercase text-sm border border-white/30 px-4 py-2 rounded-full backdrop-blur-sm" data-id="element-411">
                    View
                  </span>
                </div>
              </motion.div>)}
          </AnimatePresence>
        </motion.div>
      </section>

      {/* Lightbox Modal */}
      <AnimatePresence data-id="element-412">
        {lightboxIndex !== null && <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} exit={{
        opacity: 0
      }} className="fixed inset-0 z-[100] bg-h2o-950/95 backdrop-blur-md flex items-center justify-center p-4 md:p-12" onClick={closeLightbox} data-id="element-413">
            <button className="absolute top-6 right-6 text-white/70 hover:text-white bg-h2o-900/50 p-2 rounded-full transition-colors focus-visible-ring" onClick={closeLightbox} data-id="element-414">
              <X className="w-8 h-8" data-id="element-415" />
            </button>

            <button className="absolute left-4 md:left-12 top-1/2 -translate-y-1/2 text-white/70 hover:text-white bg-h2o-900/50 p-3 rounded-full transition-colors focus-visible-ring" onClick={prevImage} data-id="element-416">
              <ChevronLeft className="w-8 h-8" data-id="element-417" />
            </button>

            <motion.img key={lightboxIndex} initial={{
          opacity: 0,
          scale: 0.95
        }} animate={{
          opacity: 1,
          scale: 1
        }} exit={{
          opacity: 0,
          scale: 0.95
        }} transition={{
          duration: 0.2
        }} src={filteredImages[lightboxIndex].url.replace('w=600', 'w=1600')} alt="Enlarged view" className="max-w-full max-h-full object-contain rounded-lg shadow-2xl" onClick={e => e.stopPropagation()} data-id="element-418" />

            <button className="absolute right-4 md:right-12 top-1/2 -translate-y-1/2 text-white/70 hover:text-white bg-h2o-900/50 p-3 rounded-full transition-colors focus-visible-ring" onClick={nextImage} data-id="element-419">
              <ChevronRight className="w-8 h-8" data-id="element-420" />
            </button>

            <div className="absolute bottom-6 left-1/2 -translate-x-1/2 text-slate-300 text-sm bg-h2o-900/80 px-4 py-2 rounded-full backdrop-blur-sm" data-id="element-421">
              {lightboxIndex + 1} / {filteredImages.length}
            </div>
          </motion.div>}
      </AnimatePresence>

      <Footer data-id="element-422" />
    </motion.main>;
}